import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import ExcelButton from "@/components/ExcelButton";
import { fmtTL, fmtDate } from "@/lib/utils";

const STATUS = { hazirlandi: ["Hazırlandı", "bg-slate-500/15 text-slate-700 dark:text-slate-300"], onayda: ["Kontrol", "bg-sky-500/15 text-sky-700 dark:text-sky-300"],
  onaylandi: ["Onay", "bg-amber-500/15 text-amber-700 dark:text-amber-300"], odendi: ["Ödendi", "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300"] };

export function AllPayments() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/progress-payments").then(r => setRows(r.data)); }, []);
  const total = (k) => rows.reduce((s, r) => s + (r[k] || 0), 0);

  return (
    <div data-testid="all-payments">
      <div className="flex justify-end mb-3"><ExcelButton /></div>
      <div className="rounded-xl border border-border overflow-x-auto">
        <table className="w-full text-sm" data-testid="all-payments-table">
          <thead className="bg-muted/50 text-xs text-muted-foreground"><tr>
            {["Alt Yüklenici", "Sözleşme", "Hakediş", "Dönem", "Durum", "Bu Hak. (KDV Hariç)", "Kesintiler", "Net Ödenecek"].map(h => <th key={h} className="p-2 text-left whitespace-nowrap">{h}</th>)}
          </tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} className="border-t border-border hover:bg-muted/40 cursor-pointer" onClick={() => r.contract_id && navigate(`/sozlesmeler/${r.contract_id}`)} data-testid={`all-pay-${r.id}`}>
                <td className="p-2 font-semibold">{r.firm_name}</td>
                <td className="p-2 font-mono text-xs">{r.contract_no || "—"}</td>
                <td className="p-2">{r.label || `${r.payment_no} NOLU`}</td>
                <td className="p-2 whitespace-nowrap">{fmtDate(r.period_start)} – {fmtDate(r.period_end)}</td>
                <td className="p-2"><span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${STATUS[r.status]?.[1] || ""}`}>{STATUS[r.status]?.[0] || r.status}</span></td>
                <td className="p-2 text-right font-mono-nums">{fmtTL(r.gross_amount)}</td>
                <td className="p-2 text-right font-mono-nums">{fmtTL(r.deductions)}</td>
                <td className={`p-2 text-right font-mono-nums font-bold ${r.net_amount < 0 ? "text-rose-600" : ""}`}>{fmtTL(r.net_amount)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={8} className="p-6 text-center text-muted-foreground">Henüz hakediş yok.</td></tr>}
          </tbody>
          {rows.length > 0 && (
            <tfoot className="border-t-2 border-border font-bold"><tr data-testid="all-payments-total">
              <td className="p-2" colSpan={5}>TOPLAM ({rows.length} hakediş)</td>
              <td className="p-2 text-right font-mono-nums">{fmtTL(total("gross_amount"))}</td>
              <td className="p-2 text-right font-mono-nums">{fmtTL(total("deductions"))}</td>
              <td className="p-2 text-right font-mono-nums">{fmtTL(total("net_amount"))}</td>
            </tr></tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
